import { AfterViewInit, Component, EventEmitter, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { LOCAL_STORAGE_KEY } from '@core/configs';
import { ButtonType, DpadZoneType } from '@core/constants';
import { LocalStorageService } from '@core/services/common';
import { DpadControlService } from '@core/services/common/dpad-control.service';

@Component({
  selector: 'caremoni-corp-selection-tv',
  templateUrl: './corp-selection-tv.component.html',
  styleUrl: './corp-selection-tv.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class CorpSelectionTvComponent implements OnInit, AfterViewInit {
  @Output() eventPickCorp = new EventEmitter();

  DpadZoneType = DpadZoneType;
  buttonType = ButtonType;
  corpLst: any[] = [];

  constructor(
    private localStorageService: LocalStorageService,
    private dpadControlService: DpadControlService,
  ) {}

  ngOnInit(): void {
    this.bindData();
    this.dpadControlService.clearSelectItemDpad();
    this.dpadControlService.selectItemDpad();
  }

  ngAfterViewInit(): void {
    this.dpadControlService.clearSelectItemDpad();
    this.dpadControlService.selectItemDpad();
  }

  bindData(){ 
    this.corpLst = this.localStorageService.getItem(LOCAL_STORAGE_KEY.corpData);
    document.body.classList.add('dark');
    this.dpadControlService.initScreenNonLayout({
      dType: DpadZoneType.TV_CORP_SELECT,
      screenStyle: 'corp-select'
    });
  }

  onPickCorp(corp: any){ 
    this.eventPickCorp.emit(corp);
  }
}
